import apiClient from '../utils/apiClient';

export const authApi = {
  login: async (googleToken) => {
    const response = await apiClient.post('/auth/google', { token: googleToken });
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  }
};
